export const CATEGORY_FILTER_PAGE_EVENT = 'saprem:category-filter-page';

/** User actions only: never call while hydrating URL filters or restoring history. */
export function resetCategoryFilterPage() {
  const url = new URL(window.location.href);
  url.searchParams.set('page', '1');
  window.history.replaceState(null, '', `${url.pathname}?${url.searchParams}${url.hash}`);
  // Update the grid's local search snapshot in the same event as the store action.
  // Waiting for its URL-observer effect could issue a request with the old page.
  window.dispatchEvent(
    new CustomEvent(CATEGORY_FILTER_PAGE_EVENT, { detail: url.searchParams.toString() }),
  );
}
